/* ============================================================
   androidDefault.js — DEFAULT admin KONGSI (Lapis 1)
   ============================================================
   Admin bina + verify flow smooth di /android-test → simpan sebagai DEFAULT
   yang SEMUA user pakai. Disimpan dalam doc Firestore world-read (admin tulis,
   semua baca) supaya admin boleh update TANPA deploy (macam FB health). Kalau
   doc tiada / read gagal / rules belum dibenarkan → FALLBACK ke resipi dalam
   kod (robot tak pernah mati total).

   Kedudukan button disimpan sebagai RATIO (rx,ry = 0..1 daripada lebar/tinggi
   skrin) — BUKAN pixel — supaya muat pelbagai saiz skrin phone user. Runner
   skala ikut skrin user.

   Struktur doc:
     { recipes: { shopee: { version:int, positions:{ stepId:{rx,ry} } } } }

   PRIORITI runner: selector → koordinat sendiri user → default admin (ini) →
   vision. Jadi user yang dah auto-fix TAK terganggu bila admin update default
   (betulan user menang). Hanya VERSION naik → user re-calibrate (flow berubah).
   ============================================================ */

import { db, auth } from '../firebase';
import { doc, getDoc, setDoc, serverTimestamp } from 'firebase/firestore';
import { recipeFor } from './androidRecipe';

const DEFAULT_DOC = ['publicConfig', 'androidRecipe'];

let _cache = null; // cache per-muat (reload page = segar)

// Muat default admin untuk satu app. Pulang { version, positions }. Read gagal
// (doc tiada / rules belum benarkan) → fallback kod (positions kosong).
export async function loadAdminDefault(appId) {
  if (_cache === null) {
    try {
      const snap = await getDoc(doc(db, ...DEFAULT_DOC));
      _cache = snap.exists() ? (snap.data() || {}) : {};
    } catch { _cache = {}; }
  }
  const fromDoc = _cache && _cache.recipes ? _cache.recipes[appId] : null;
  const code = recipeFor(appId);
  const positions = (fromDoc && typeof fromDoc.positions === 'object' && fromDoc.positions) || {};
  const version = Number(fromDoc?.version) || Number(code?.version) || 1;
  return { version, positions };
}

// ADMIN SAHAJA — simpan default (dipanggil dari /android-test selepas verify).
// positions = { stepId:{rx,ry} }. bumpVersion=true bila FLOW berubah (paksa
// semua user re-calibrate); false untuk tuning posisi (user sedia ada tak
// terganggu). ⚠️ Tulisan ke production — gate izin di pemanggil.
export async function saveAdminDefault(appId, positions, { bumpVersion = false } = {}) {
  const cur = await loadAdminDefault(appId);
  const version = bumpVersion ? (cur.version + 1) : cur.version;
  // Semak ratio sebelum tulis (0..1) — jangan simpan nilai rosak.
  const clean = {};
  Object.entries(positions || {}).forEach(([k, v]) => {
    const rx = Number(v?.rx), ry = Number(v?.ry);
    if (Number.isFinite(rx) && Number.isFinite(ry) && rx >= 0 && rx <= 1 && ry >= 0 && ry <= 1) {
      clean[k] = { rx: Math.round(rx * 10000) / 10000, ry: Math.round(ry * 10000) / 10000 };
    }
  });
  await setDoc(doc(db, ...DEFAULT_DOC), {
    recipes: { [appId]: { version, positions: clean, updatedAt: serverTimestamp(), updatedBy: auth.currentUser?.email || '' } },
  }, { merge: true });
  _cache = null; // paksa muat semula lepas ni
  return { version, count: Object.keys(clean).length };
}

export function clearDefaultCache() { _cache = null; }
